// Predefined categories for Home Cafe
export const CATEGORIES = [
  'Starters',
  'Soups',
  'Main Course - Veg',
  'Main Course - Non-Veg',
  'Breads',
  'Rice & Biryanis',
  'Desserts',
  'Beverages'
];

// Multi-restaurant data storage (shared with Admin via localStorage)
const STORAGE_KEY = 'MenuBazzar_restaurants';
const DEFAULT_RESTAURANT_ID = 'default';

// Helper to get restaurants from localStorage
const getStoredRestaurants = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  }
  return {};
};

// Helper to save restaurants to localStorage
const saveRestaurants = (restaurants) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(restaurants));
  }
};

// Initialize default restaurant with sample data
let defaultMenuItems = [
  // Starters
  {
    id: 1,
    name: 'Paneer Tikka',
    description: 'Cubes of cottage cheese marinated in spices and grilled in tandoor',
    price: 299,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Starters',
    diet: 'Veg',
    spice: 'Medium',
    popular: true,
    cuisine: 'North Indian'
  },
  {
    id: 2,
    name: 'Chicken 65',
    description: 'Spicy, deep-fried chicken appetizer with curry leaves and spices',
    price: 349,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Starters',
    diet: 'Non-Veg',
    spice: 'Spicy',
    popular: true,
    cuisine: 'South Indian'
  },
  {
    id: 3,
    name: 'Aloo Tikki',
    description: 'Crispy potato patties served with chutneys',
    price: 199,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Starters',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'North Indian'
  },
  
  // Soups
  {
    id: 4,
    name: 'Tomato Shorba',
    description: 'Spiced tomato soup tempered with cumin and coriander',
    price: 149,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Soups',
    diet: 'Veg',
    spice: 'Mild',
    popular: false,
    cuisine: 'Indian'
  },
  
  // Main Course - Veg
  {
    id: 5,
    name: 'Paneer Butter Masala',
    description: 'Cottage cheese cubes in rich tomato and cashew gravy',
    price: 349,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Main Course - Veg',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'North Indian'
  },
  {
    id: 6,
    name: 'Dal Makhani',
    description: 'Black lentils and kidney beans slow-cooked with butter and cream',
    price: 299,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Main Course - Veg',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'North Indian'
  },
  
  // Main Course - Non-Veg
  {
    id: 7,
    name: 'Butter Chicken',
    description: 'Tandoori chicken in rich tomato and butter gravy',
    price: 449,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Main Course - Non-Veg',
    diet: 'Non-Veg',
    spice: 'Medium',
    popular: true,
    cuisine: 'North Indian'
  },
  {
    id: 8,
    name: 'Lamb Rogan Josh',
    description: 'Tender lamb cooked in aromatic Kashmiri red gravy',
    price: 549,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Main Course - Non-Veg',
    diet: 'Non-Veg',
    spice: 'Spicy',
    popular: false,
    cuisine: 'Kashmiri'
  },
  
  // Breads
  {
    id: 9,
    name: 'Butter Naan',
    description: 'Tandoor-baked leavened bread with butter',
    price: 99,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Breads',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'Indian'
  },
  {
    id: 10,
    name: 'Garlic Naan',
    description: 'Tandoor-baked bread with garlic and coriander',
    price: 119,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Breads',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'Indian'
  },
  
  // Rice & Biryanis
  {
    id: 11,
    name: 'Veg Biryani',
    description: 'Fragrant basmati rice cooked with mixed vegetables and spices',
    price: 299,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Rice & Biryanis',
    diet: 'Veg',
    spice: 'Medium',
    popular: true,
    cuisine: 'Hyderabadi'
  },
  {
    id: 12,
    name: 'Chicken Dum Biryani',
    description: 'Aromatic rice with tender chicken, slow-cooked in dum style',
    price: 399,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Rice & Biryanis',
    diet: 'Non-Veg',
    spice: 'Spicy',
    popular: true,
    cuisine: 'Hyderabadi'
  },
  
  // Desserts
  {
    id: 13,
    name: 'Gulab Jamun',
    description: 'Deep-fried milk dumplings in sugar syrup',
    price: 149,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Desserts',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'Indian'
  },
  {
    id: 14,
    name: 'Gajar Ka Halwa',
    description: 'Carrot pudding with nuts and cardamom',
    price: 179,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Desserts',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'Indian'
  },
  
  // Beverages
  {
    id: 15,
    name: 'Mango Lassi',
    description: 'Refreshing yogurt-based mango drink',
    price: 149,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Beverages',
    diet: 'Veg',
    spice: 'Mild',
    popular: true,
    cuisine: 'Indian'
  },
  {
    id: 16,
    name: 'Masala Chai',
    description: 'Traditional Indian spiced tea with milk',
    price: 99,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400',
    category: 'Beverages',
    diet: 'Veg',
    spice: 'Medium',
    popular: true,
    cuisine: 'Indian'
  }
];

let defaultOrders = [];
let orderIdCounter = parseInt(typeof window !== 'undefined' ? localStorage.getItem('orderIdCounter') || '1' : '1', 10);

// Initialize default restaurant if not exists
const initializeDefaultRestaurant = () => {
  const restaurants = getStoredRestaurants();
  if (!restaurants[DEFAULT_RESTAURANT_ID]) {
    restaurants[DEFAULT_RESTAURANT_ID] = {
      id: DEFAULT_RESTAURANT_ID,
      name: 'Home Cafe',
      email: 'admin@homecafe.com',
      menuItems: defaultMenuItems.map(item => ({ ...item, enabled: item.enabled !== false })),
      orders: defaultOrders,
      menuItemIdCounter: Math.max(...defaultMenuItems.map(i => i.id), 0)
    };
    saveRestaurants(restaurants);
  }
};

// Initialize on load
if (typeof window !== 'undefined') {
  initializeDefaultRestaurant();
}

// Helper to get current restaurant ID from localStorage or default
const getCurrentRestaurantId = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('currentRestaurantId') || DEFAULT_RESTAURANT_ID;
  }
  return DEFAULT_RESTAURANT_ID;
};

// Helper to get restaurant data
const getRestaurantData = (restaurantId = null) => {
  const restaurants = getStoredRestaurants();
  const id = restaurantId || getCurrentRestaurantId();
  
  if (!restaurants[id]) {
    restaurants[id] = {
      id: id,
      name: 'New Restaurant',
      menuItems: [],
      orders: [],
      menuItemIdCounter: 0
    };
    saveRestaurants(restaurants);
  }
  return restaurants[id];
};

// Restaurant management functions
export const createRestaurant = (restaurantData) => {
  const restaurants = getStoredRestaurants();
  const restaurantId = `restaurant_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  
  restaurants[restaurantId] = {
    id: restaurantId,
    name: restaurantData.name || 'New Restaurant',
    email: restaurantData.email,
    phone: restaurantData.phone || '',
    address: restaurantData.address || '',
    menuItems: [],
    orders: [],
    menuItemIdCounter: 0,
    createdAt: new Date().toISOString()
  };
  
  saveRestaurants(restaurants);
  return restaurants[restaurantId];
};

export const getRestaurantById = (restaurantId) => {
  const restaurants = getStoredRestaurants();
  return restaurants[restaurantId] || null;
};

export const authenticateRestaurant = (email, password) => {
  const restaurants = getStoredRestaurants();
  const restaurant = Object.values(restaurants).find(r => r.email === email);
  if (restaurant) {
    if (typeof window !== 'undefined') {
      localStorage.setItem('currentRestaurantId', restaurant.id);
      localStorage.setItem('restaurantAuth', 'true');
    }
    return restaurant;
  }
  return null;
};

export const getCurrentRestaurant = () => {
  const restaurants = getStoredRestaurants();
  const id = getCurrentRestaurantId();
  return restaurants[id] || null;
};

export const logoutRestaurant = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('currentRestaurantId');
    localStorage.removeItem('restaurantAuth');
  }
};

export const isRestaurantAuthenticated = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('restaurantAuth') === 'true';
  }
  return false;
};

// Menu item functions (restaurant-scoped)
export const getMenuItems = (restaurantId = null) => {
  const restaurant = getRestaurantData(restaurantId);
  const items = restaurant.menuItems || [];
  // Filter out disabled items for customer view, but include all for admin/restaurant views
  const isAdminOrRestaurant = typeof window !== 'undefined' && 
    (window.location.pathname.includes('/restaurant') || 
     window.location.pathname.includes('/admin') ||
     window.location.pathname.includes('/dashboard') ||
     (window.location.pathname.includes('/menu') && window.location.pathname.includes('/admin')));
  return isAdminOrRestaurant ? items : items.filter(item => item.enabled !== false);
};

export const getMenuItemsByCategory = (category, restaurantId = null) => {
  const items = getMenuItems(restaurantId);
  return items.filter(item => item.category === category);
};

export const getCategories = () => CATEGORIES;

export const getMenuItemById = (id, restaurantId = null) => {
  const items = getMenuItems(restaurantId);
  return items.find(item => item.id === parseInt(id));
};

export const addMenuItem = (item, restaurantId = null) => {
  const restaurants = getStoredRestaurants();
  const restaurant = getRestaurantData(restaurantId);
  const newItem = {
    ...item,
    id: ++restaurant.menuItemIdCounter,
    enabled: item.enabled !== false
  };
  
  if (!restaurant.menuItems) {
    restaurant.menuItems = [];
  }
  
  restaurant.menuItems.push(newItem);
  restaurants[restaurant.id] = restaurant;
  saveRestaurants(restaurants);
  return newItem;
};

export const updateMenuItem = (id, updates, restaurantId = null) => {
  const restaurants = getStoredRestaurants();
  const restaurant = getRestaurantData(restaurantId);
  
  if (!restaurant.menuItems) {
    restaurant.menuItems = [];
  }
  
  const index = restaurant.menuItems.findIndex(item => item.id === parseInt(id));
  if (index !== -1) {
    restaurant.menuItems[index] = { ...restaurant.menuItems[index], ...updates };
    restaurants[restaurant.id] = restaurant;
    saveRestaurants(restaurants);
    return restaurant.menuItems[index];
  }
  return null;
};

export const deleteMenuItem = (id, restaurantId = null) => {
  const restaurants = getStoredRestaurants();
  const restaurant = getRestaurantData(restaurantId);
  
  if (!restaurant.menuItems) {
    restaurant.menuItems = [];
  }
  
  restaurant.menuItems = restaurant.menuItems.filter(item => item.id !== parseInt(id));
  restaurants[restaurant.id] = restaurant;
  saveRestaurants(restaurants);
};

export const toggleMenuItemEnabled = (id, enabled, restaurantId = null) => {
  return updateMenuItem(id, { enabled: enabled !== false }, restaurantId);
};

// Order functions (restaurant-scoped)
export const createOrder = (orderData, restaurantId = null) => {
  const restaurants = getStoredRestaurants();
  const restaurant = getRestaurantData(restaurantId);
  
  if (!restaurant.orders) {
    restaurant.orders = [];
  }
  
  const order = {
    id: orderIdCounter++,
    ...orderData,
    restaurantId: restaurant.id,
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  
  restaurant.orders.push(order);
  restaurants[restaurant.id] = restaurant;
  saveRestaurants(restaurants);
  
  if (typeof window !== 'undefined') {
    localStorage.setItem('orderIdCounter', orderIdCounter.toString());
  }
  
  return order;
};

export const getOrders = (restaurantId = null) => {
  const restaurant = getRestaurantData(restaurantId);
  return restaurant.orders || [];
};

export const getOrdersByTable = (tableNumber, restaurantId = null) => {
  const orders = getOrders(restaurantId);
  return orders.filter(order => order.tableNumber === tableNumber);
};

export const getPendingOrders = (restaurantId = null) => {
  const orders = getOrders(restaurantId);
  return orders.filter(order => order.status === 'pending');
};

export const getOrderById = (id, restaurantId = null) => {
  const orders = getOrders(restaurantId);
  return orders.find(order => order.id === parseInt(id));
};

export const updateOrderStatus = (id, status, restaurantId = null) => {
  const restaurants = getStoredRestaurants();
  const restaurant = getRestaurantData(restaurantId);
  
  if (!restaurant.orders) {
    restaurant.orders = [];
  }
  
  const order = restaurant.orders.find(o => o.id === parseInt(id));
  if (order) {
    order.status = status;
    order.updatedAt = new Date().toISOString();
    restaurants[restaurant.id] = restaurant;
    saveRestaurants(restaurants);
    return order;
  }
  return null;
};

